export default "__VITE_ASSET__CO7u5jTE__"